import styled from "styled-components";

export const FooterWrapper = styled.footer`
  width: 100%;
  display: flex;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colors.secundaria};
  padding: 25px 0;
`;

export const CopyrightWrapper = styled.span`
  width: fit-content;
  margin: 0 auto;
  color: #999;
`;
